<!--
 * @Author: your name
 * @Date: 2022-03-04 17:54:06
 * @LastEditTime: 2022-03-09 20:02:49
 * @LastEditors: Please set LastEditors
 * @Description: 电子合同-意愿验证成功页面
 * @FilePath: \wx-front\src\views\contract\signPassed.vue
-->
<template>
<div class="wrap colAc fontH3">
    <img src="../../assets/static/contract/certificationPassed.svg" class="passImg" alt="">
    <div class="fontScN7 fontH1 passText medium">签署通过</div>
    <div class="ensureBtn rowJcAc fontScW bgcMcA1" @click="clickEnsure">确定</div>
</div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
   computed: {
    },
    watch: {
    },
  created() {
    // 认证成功的变量赋值1
    this.$common.setCache('isRealName',1)
  },
  mounted() {
  },
  methods: {
    //点击确定
    clickEnsure(){
      this.$router.go(-4)
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap {  
background: #fff;
height: 100%;
font-size: 14px;
padding: 1.2rem 0.24rem 0 0.24rem;
box-sizing: border-box;
}

.passImg{
    width: 1.18rem;
    height: 1.18rem;
}
.passText{
    margin: 8px 0 64px 0;
}
.ensureBtn{
    width: 100%;
    height: 44px;
    border-radius: 6px;
}
</style>
